import { type ReactRouterBridge } from 'Navigation/angularModule/scripts/react_router_bridge';

/*
    Back when we were just using AngularJS, it seemed useful to track locations based on
    the directive, regardless of which path was pointing at that directive. With React routes, though,
    we expose the React Router state directly. For logging purposes we still refer to the identifier
    as a directive, falling back to the pathname if we don't have a generated name.
*/
export default function getDirectiveForEvents(reactRouterBridge: ReactRouterBridge): string | null {
    return reactRouterBridge.routeName || reactRouterBridge.path() || null;
}
